"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_final_form_1 = require("react-final-form");
const index_1 = require("../../components/index");
function NumberField({ name, label, validate, parse, format, }) {
    const [val, setVal] = (0, react_1.useState)();
    return (react_1.default.createElement(react_final_form_1.Field, { name: name, validate: validate, parse: parse, format: format }, ({ input, meta }) => {
        // set initial value
        (0, react_1.useEffect)(() => {
            if (input.value !== undefined) {
                setVal(String(input.value));
            }
        }, []);
        const onChange = (value) => {
            setVal(value);
            input.onChange(value);
        };
        return (react_1.default.createElement(index_1.MaskedInput, { name: name, mask: "integer", fullWidth: true, value: val, label: label, onChange: onChange, error: meta.touched && meta.error, helperText: meta.touched && meta.error }));
    }));
}
exports.default = NumberField;
